import styled from 'styled-components';
import { useField, useFormikContext } from 'formik';

export const Container = styled.span`
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
`;

function ErrorMessage({ name, ...props }) {
  const [, meta] = useField(name);
  const { submitCount } = useFormikContext();
  const shouldShowError = Boolean((meta.touched || submitCount > 0) && meta.error);

  if (!shouldShowError) {
    return null;
  }

  return (
    <Container className="invalid-feedback" role="alert" {...props}>
      {meta.error}
    </Container>
  );
}

export default ErrorMessage;
